import styled from 'styled-components';
import { node, string, bool } from 'prop-types';

import RouterLink from './RouterLink';
import StyledText from './StyledText';

import { SMALL_TEXT, LAPTOP_SIZE } from '../../constants/index';

const Container = styled.div`
  display: flex;
  align-items: center;
  margin: 0px 25px;
  position: relative;
  cursor: pointer;

  span {
    width: ${({ isSelected }) => isSelected && '100%'};
  }

  :hover span {
    width: 100%;
  }

  @media (max-width: ${LAPTOP_SIZE}) {
    margin-top: 30px;
    padding-bottom: 10px;
  }
`;

const UnderlineAnimation = styled.span`
  position: absolute;
  bottom: -5px;
  left: 0;
  width: 0%;
  height: 2px;
  background: ${({ color }) => color};
  transition: all 0.6s;
`;

const MenuItem = ({ children, href, pathname, fontColor }) => (
  <Container isSelected={href === pathname}>
    <RouterLink href={href}>
      <StyledText color={fontColor} size={SMALL_TEXT}>
        {children}
      </StyledText>
    </RouterLink>
    <UnderlineAnimation color={fontColor} />
  </Container>
);

MenuItem.propTypes = {
  children: node.isRequired,
  href: string.isRequired,
  pathname: string.isRequired,
  fontColor: string.isRequired,
  isSelected: bool,
};

export default MenuItem;



// WEBPACK FOOTER //
// components/shared/MenuItem.js